import { Form } from '@anytag/shared-atoms';
import { TikTokPasswordFormSchema } from './schema';
import { Template } from './Template';
import { TikTokPasswordFormProps, TikTokPasswordFormValues } from './types';

export const TikTokPasswordForm = ({
  onSubmit,
  defaultValues = { password: '', passwordConfirm: '' }
}: TikTokPasswordFormProps) => (
  <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={TikTokPasswordFormSchema}>
    <Template />
  </Form.Provider>
);

export { type TikTokPasswordFormValues };
